// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"ResultPage_Wrapper__yolAK","Title":"ResultPage_Title__fm8k9"};